import Vue from 'vue';
import VueFormulate from '@braid/vue-formulate'
import { es } from '@braid/vue-formulate-i18n'
// import FormulateVueFacilitiesPlugin from './FormulateVueFacilities'
import FormulateVueInputSliderPlugin from './FormulateVueInputSlider'
import rules from './rules'
import ReviewCommentsFormulateInput from '@/components/BuildSecuritySelfAuditForm/ReviewCommentsPerQuestion.vue'
import Commands from '@/components/operationalSecurity/BuildForm/Commands.vue'
import UserSelect from '@/components/operationalSecurity/BuildForm/UserSelect.vue'
import FacilitySelect from '@/components/operationalSecurity/BuildForm/FacilitySelect.vue'
import MailList from '@/components/operationalSecurity/BuildForm/MailList.vue';
import Recipient from '@/components/operationalSecurity/BuildForm/Recipient.vue';
import RelatedForms from '@/components/operationalSecurity/BuildForm/RelatedForms.vue';
import Time from '@/components/operationalSecurity/BuildForm/Time.vue';
import UserList from '@/components/operationalSecurity/BuildForm/UserList.vue';
import Date from '@/components/operationalSecurity/BuildForm/Date.vue';
import Folio from '@/components/operationalSecurity/BuildForm/Folio.vue';
import Region from '@/components/operationalSecurity/BuildForm/Region.vue';
import Timestamp from '@/components/operationalSecurity/BuildForm/Timestamp.vue';
import MultipleSelect from '@/components/BuildForm/MultipleSelect.vue';
import DeviceDoc from '@/components/operationalSecurity/BuildForm/DeviceDoc.vue';
import Supplier from '@/components/operationalSecurity/BuildForm/Supplier.vue';
import Technicians from '@/components/operationalSecurity/BuildForm/Technicians.vue';
import RhUsers from '@/components/operationalSecurity/BuildForm/RhUsers.vue';

Vue.component('ReviewCommentsFormulateInput', ReviewCommentsFormulateInput)


Vue.use(VueFormulate, {
    plugins: [
      es,
      // FormulateVueFacilitiesPlugin,
      // FormulateVueInputSliderPlugin,
    ],
    locale: 'es',
    rules,
    library: {
      reviewcomments: {
        classification: 'component',
        component: 'ReviewCommentsFormulateInput',
      //props personalizadas desde el schema:
        slotProps: {
          component: ['questionName','disabled'],
        },
      },
      commands: {
        classification: 'custom',
        component: Commands,
        slotProps: {
          component: ['context', 'fieldOptions']
        }
      },
      userSelect: {
        classification: 'custom',
        component: UserSelect,
        slotProps: {
          component: ['context', 'fieldOptions']
        }
      },
      facilitySelect: {
        classification: 'custom',
        component: FacilitySelect,
        slotProps: {
          component: ['context', 'fieldOptions']
        }
      },
      mailList: {
        classification: 'custom',
        component: MailList,
        slotProps: {
          component: ['context', 'fieldOptions']
        }
      },
      recipient: {
        classification: 'custom',
        component: Recipient,
        slotProps: {
          component: ['context', 'fieldOptions']
        }
      },
      relatedForms: {
        classification: 'custom',
        component: RelatedForms,
        slotProps: {
          component: ['context', 'fieldOptions']
        }
      },
      time24Hrs: {
        classification: 'custom',
        component: Time,
        slotProps: {
          component: ['context', 'fieldOptions']
        }
      },
      customDate: {
        classification: 'custom',
        component: Date,
        slotProps: {
          component: ['context', 'fieldOptions']
        }
      },
      userList: {
        classification: 'custom',
        component: UserList,
        slotProps: {
          component: ['context', 'fieldOptions']
        }
      },
      folio: {
        classification: 'custom',
        component: Folio,
        slotProps: {
          component: ['context', 'fieldOptions']
        }
      },
      region: {
        classification: 'custom',
        component: Region,
        slotProps: {
          component: ['context', 'fieldOptions']
        }
      },
      timestamp: {
        classification: 'custom',
        component: Timestamp,
        slotProps: {
          component: ['context', 'fieldOptions']
        }
      },
      multipleSelect: {
        classification: 'custom',
        component: MultipleSelect,
        slotProps: {
          component: ['context', 'fieldOptions', 'options']
        }
      },
      deviceDoc: {
        classification: 'custom',
        component: DeviceDoc,
        slotProps: {
          component: ['context', 'fieldOptions']
        }
      },
      supplier: {
        classification: 'custom',
        component: Supplier,
        slotProps: {
          component: ['context', 'fieldOptions']
        }
      },
      technicians: {
        classification: 'custom',
        component: Technicians,
        slotProps: {
          component: ['context', 'fieldOptions']
        }
      },
      rhUsers: {
        classification: 'custom',
        component: RhUsers,
        slotProps: {
          component: ['context', 'fieldOptions']
        }
      },
    },
    classes: {
      groupRepeatable: 'vf-row',
      groupRepeatableRemove: 'btn-remove-group'
    }
})
